import { render, staticRenderFns } from "./retail-info.vue?vue&type=template&id=7320a1ac"
import script from "./retail-info.vue?vue&type=script&lang=js"
export * from "./retail-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports